import { Locale, type Localized } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: Localized<string> = {
	[Locale.cs]: "/ochrana-osobnich-udaju",
};

export function getPrivacyPolicyPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
